import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { ReactElement, useState } from 'react';

import { ICeDocument } from '~/services/api/communityEngagement/types';
import { IResource } from '~/services/api/resource/types';
import { ReactComponent as PreviewIcon } from '~/ui/assets/images/previewFile.svg';
import FileViewer from '~/ui/pages/Resources/components/FileViewer';
import getFileTypeIcon from '~/ui/pages/Resources/helpers/getFileTypeIcon';

import formatCeDocument from '~/ui/pages/Clients/reusable/CommunityEngagement/helpers/formatCeDocument';

import styles from './DocumentList.module.scss';

const VISIBLE_DOCUMENTS = 3;

interface IDocumentListProps {
  documents: ICeDocument[];
}

const DocumentList = ({ documents }: IDocumentListProps): ReactElement => {
  const [expanded, setExpanded] = useState(false);
  const [preview, setPreview] = useState<IResource | null>(null);

  const visible = expanded ? documents : documents.slice(0, VISIBLE_DOCUMENTS);
  const files = visible.map(formatCeDocument);

  return (
    <>
      <ul className={styles.documentList}>
        {files.map(file => (
          <li key={file.id} className={styles.document}>
            <span className={styles.documentIcon}>{getFileTypeIcon(file.type)}</span>
            <span className={styles.documentName}>{file.name}</span>
            <IconButton
              aria-label={`Preview ${file.name}`}
              size="small"
              onClick={() => setPreview(file)}
            >
              <PreviewIcon width={20} height={20} />
            </IconButton>
          </li>
        ))}
      </ul>
      {documents.length > VISIBLE_DOCUMENTS && (
        <Button
          color="primary"
          size="small"
          className={styles.showMore}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? 'Show Less' : 'Show More'}
        </Button>
      )}
      {preview && <FileViewer file={preview} onClose={() => setPreview(null)} />}
    </>
  );
};

export default DocumentList;
